export const SLOGANS = [
  "Survive the Arena",
  "Only One Rolls Out",
  "Enter the Pit. Earn Your Exit.",
  "Fight the Roll",
  "No Mercy in the Pit",
  "Leave the Arena or Break"
] as const;

export const EXP_PER_LEVEL = 250;

export const INITIAL_GRID = [[null, null, null], [null, null, null], [null, null, null]] as const;

// ── Super Dice mechanics ───────────────────────────────────────────────────────
export const SUPER_DICE_CHANCE = 0.30;
export const SHIELD_DURATION_ROUNDS = 2;

// ── Validation constants ────────────────────────────────────────────────────────
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_USERNAME_LENGTH = 12;
export const MAX_CHAT_MESSAGE_LENGTH = 500;
export const MAX_ROOM_CODE_LENGTH = 36;

// ── Timing constants ────────────────────────────────────────────────────────────
export const CONFETTI_DURATION_MS = 4000;
export const CONFETTI_PARTICLE_COUNT = 60;
export const TOAST_DURATION_MS = 1200;
export const LAST_ACTION_HIGHLIGHT_MS = 500;

// ── Guest name generation ───────────────────────────────────────────────────────
export const GUEST_NAME_WORDS = [
  'dearth', 'quence', 'cerned', 'douche', 'qualed', 'feints', 'sealed', 'horred',
  'merced', 'grains', 'housed', 'heaves', 'prelim', 'shaled', 'hoofed', 'flaunt',
  'nesced', 'plague', 'guised', 'loosed', 'treach', 'bashed', 'strife', 'clinch',
  'graine', 'thatch', 'throes', 'rhymed', 'scotch', 'strick', 'entist', 'cinque',
  'cracks', 'picked', 'praise', 'strode', 'gneiss', 'sheath', 'poised', 'spleen',
  'borsch', 'graced', 'starve', 'pained', 'tridge', 'steppe', 'shrift', 'prince',
  'bushed', 'shrank', 'polled', 'boards', 'shrink', 'nerves', 'faints', 'celled',
  'clench', 'gunned', 'bathed', 'breech', 'creeps', 'marred', 'trumps', 'stayed',
  'ringed', 'blamed', 'sprink', 'tapped', 'sience', 'terred', 'thirst', 'scured',
  'joined', 'stinct', 'spaced', 'tchouc', 'punged', 'blanch', 'capped', 'thrive',
  'struct', 'please', 'trails', 'forged', 'sports', 'densed', 'chrome', 'cringe',
  'shelve', 'merged', 'skirts', 'selled', 'broach', 'phones', 'snitch', 'venged',
  'quench', 'hanced', 'darned', 'sprock', 'plowed', 'belled', 'scythe', 'psalms',
  'strang', 'finned', 'dreams', 'quette', 'spoilt', 'sphere', 'script', 'sheave',
  'talled', 'nights', 'rolled', 'scourg', 'fright', 'zipped', 'chined', 'pounce',
  'glooms', 'manned', 'dreamt', 'scious', 'groats', 'hemmed', 'graves', 'dodged',
  'strobe', 'jounce', 'grille', 'queath', 'prised', 'turbed', 'lottes', 'nulled',
  'scrawn', 'trades', 'solved', 'cirque', 'scoped', 'corned', 'prance', 'whites',
  'strewn', 'sought', 'broads', 'sculpt', 'gainst', 'psyche', 'cashed', 'hooked',
  'delled', 'prayer', 'pinged', 'strafe', 'spathe', 'croach', 'kissed', 'schaum',
  'corked', 'drench', 'hanged', 'willed', 'nanced', 'clared', 'horsed', 'thized',
  'seethe', 'sketch', 'resced', 'squeal', 'tolled', 'troops', 'gaines', 'wagged',
  'hearse', 'quoise', 'bugged', 'globin', 'framed', 'earned', 'phragm', 'sprain',
  'resque', 'spoils', 'lesque', 'shrove', 'scribe', 'strain', 'slaugh', 'dredth',
  'worked', 'strive', 'scotts', 'creche', 'tracks', 'cheers', 'gassed', 'verged',
] as const;

/** Generate a random guest name: {word}{3-digit} (e.g. praise472) */
export function generateGuestName(): string {
  const word = GUEST_NAME_WORDS[Math.floor(Math.random() * GUEST_NAME_WORDS.length)];
  const digits = String(Math.floor(Math.random() * 900) + 100); // 100-999
  return `${word}${digits}`;
}
